import { ApNotification } from "@Mobile-Leaves-CORP/ap-components"
import i18n from "../locales"

const defaultStyle = "padding: .5rem 1rem;margin:0"
const defaultMessages = {
  success: "",
  error: i18n.global.t("component.alert.contact.support.label")
}

export default function useToastManager() {
  function success(
    options = { title: null, message: null, config: null, duration: null, style: null }
  ) {
    ApNotification.success({
      title: options?.title ?? null,
      description: options?.message ?? defaultMessages["success"],
      config: options?.config ?? {},
      style: `${options?.style ? options?.style + ";" : ""}${defaultStyle}`
    })
  }

  function error(options = { message: null, config: null, duration: null, style: null }) {
    ApNotification.error({
      title: options?.title ?? null,
      description: options?.message ?? defaultMessages["error"],
      config: options?.config ?? {},
      style: `${options?.style ? options?.style + ";" : ""}${defaultStyle}`
    })
  }

  return { ...ApNotification, success, error }
}
